module.exports = __webpack_public_path__ + "static/mesh-small-mobile-2810c20069ef792ed0edd99d73bd2bae.svg";